const tooltip = {
    init: () => {
        const $window = $(window);
        tooltip.el = $('#tooltipContent');
        tooltip.timer = 0;

        $(document).on('click', '.tooltip', function onToolTipClick(e) {
            const that = $(this);
            const msTimer = that.data('tiptimer') || 2500;
            const maxWidth = that.data('tipwidth') || 150;
            let offsetRight = 'auto';
            let offsetLeft = 'auto';
            let offsetTop = 'auto';

            offsetTop = that.offset().top + that.height() + 5;
            if ($window.width() - that.offset().left - 150 < 0) {
                offsetRight = $window.width() - that.offset().left - that.width();
                tooltip.el.addClass('aRight');
            } else if (that.width() >= 150) {
                offsetLeft = e.pageX;
            } else {
                offsetLeft = that.offset().left;
                tooltip.el.removeClass('aRight');
            }

            clearTimeout(tooltip.timer);
            tooltip.el.text(that.data('tiptext')).css({
                maxWidth: `${maxWidth}px`,
                top: offsetTop,
                left: offsetLeft,
                right: offsetRight,
            }).show();

            tooltip.timer = setTimeout(() => {
                tooltip.el.fadeOut();
                $window.off('scroll.tooltip');
            }, msTimer);

            $window.on('scroll.tooltip', () => {
                $window.off('scroll.tooltip');
                tooltip.el.fadeOut();
                clearTimeout(tooltip.timer);
            });
        });
    },
};

export default tooltip;
